import React, { Suspense, useEffect, useState } from 'react';
import FormGenerator from '../../../Cells/Form/FormGenerator';
import { Banner, Checkbox, Button, Linker } from '../../../Atoms';
//import { useSelector } from 'react-redux';
import SectionHeader from '../../../Molecules/SectionHeader';
import { useDispatch, useSelector } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { callConstants } from '../../../../Store/Slices/Entities/constants/index';
import { constantsList } from '../../../../Common/Constants/index';
import { MercerButton } from '../../../Atoms';
import './styles.css';
import { SET_MFA_SERVICE_UNAVAILABLE, SET_SEND_EMAIL_CHALLENGE_ERROR } from '../../../../Store/Slices/RegisterationError';
import newForgotUserNameSad from '../../../../Assets/Images/NewForgotUserNameSad.png'; 
import newForgotUserNameHappy from '../../../../Assets/Images/NewForgotUserNameHappy.png'; 

const GetUserInformation = (props) => {
  const { currentLanguage } = useSelector((storeState) => storeState.language);
  const {retrieved}  = useSelector((storeState) => storeState.forgotUser);
  const {currentStep}  = useSelector((storeState) => storeState.stepForm);

  const [content, SetContent] = useState({ banner: {} });
  const dispatch = useDispatch();

  useEffect(() => {
    import(`./Content/${currentLanguage}.json`)
      .then(module => SetContent(module.default))
      .catch(error => console.error("Failed to load content:", error));
  }, [currentLanguage]);

  const { title, subtitle, panelTitle, banner = {}, icon, layout } = content || {};

  useEffect(() => {
    /* useEffect to get all constants through API call */
    constantsList.forEach((element) => {
      dispatch(callConstants(element));
    });
    dispatch(SET_SEND_EMAIL_CHALLENGE_ERROR({ hasError: false, clearCount: false, form: currentStep }))
  }, []);
  const breadcrumbs = [
    { to: '', text: 'Employee' },
    { to: '/searchForAnEmployee', text: 'Search for an Employee' },
  ];
  // const [duration, setDuration] = useState(45);
  //     const [paused, setPaused] = useState(true);
    
  //     useEffect(() => {
  //       let timerId;
  //       if (!paused) {
  //         timerId = setInterval(() => {
  //           setDuration((prev) => prev - 1);
  //         }, 1000);
  //         
  //       }
    
  //       return function cleanup() {
  //       
  //         clearInterval(timerId);
  //       };
  //     }, [paused]);
    
  //     const handleClick = (e) => {
  //       !paused ? setPaused(true) : setPaused(false);
  //     };
  //  const [content1, setContent] = useState({
  //    title: '',
  //    subtitle: '',
  //    panelTitle: '',
  //    banner: {},
  //    icon: '',
  //    authUrl: '',
  //    redirectUrl: '',
  //    helpLinks: [],
  //    inputPlaceHolder: '',
  //    passwordPlaceHolder: '',
  //    buttonLable: '',
  //    rememberMeLable: '',
  //  });
  const notify = () =>
    toast.error(
      <div>
        You have exceeded the maximum number (3) of attempts. Please contact Mercer Contact Center @
        (xxx) - (xxx) - (xxxx)' for further assistance.'
      </div>
    );
  return (
    <div>
      <Suspense fallback={<div>Loading...</div>}>
        {/* <div>
        {duration >= 0 ? <h3>{duration}</h3> : setDuration(0)}
          <button paused={paused} onClick={handleClick} />
        </div> */}
        <div class="container-fluid">
          <div class="row py-3 mt-4">
            <div className={`  ${layout && layout.dualColumn ? layout.dualColumn[0] : 'col-md-12'} `}>
              {!retrieved && <img
                src={newForgotUserNameSad}
                alt=""
                id="retrieve-user-image"
              />
              }
              {retrieved && <img
                src={newForgotUserNameHappy}
                alt=""
                id="retrieve-user-image"
              />
              }
            </div>
            <div className={`  ${layout && layout.dualColumn ? layout.dualColumn[1] : 'col-md-12'} `} id="dualColumn" >
              <Toaster
                toastOptions={{
                  className: 'toast-message',
                  duration: 3000,

                  style: {
                    border: '1px solid #E6A7A3',
                    padding: '16px',
                    color: '#AB2F26',
                    background: '#FFE8E6',
                  },
                }}
              />

              <div className="formWrapper">
                {/* <div className="form-row py-3 mt-4"> */}
                <FormGenerator content={content} {...props} />
              </div>
            </div>
          </div>
        </div>
      </Suspense>
    </div>
  );
};

export default GetUserInformation;
